import {Shape} from './index.js';

export class Circle extends Shape {
	draw(context) {
		context.save();
		context.beginPath();
		context.arc(this.position.x, this.position.y, this.size.width / 2, 0, Math.PI * 2);
		this.applyStyles(context);
		context.fill();
		this.beforeRestore(context)
		context.restore();
	}
}
